/**
 * The name of the caller's organisation for the context chips (#1170). Read
 * once per page from the profile; a failed read is retried on the next
 * opening, and until then the chip is simply missing.
 */
import { backendUserProfilesService } from '@/services/backend-user-profiles-service'

let pending: Promise<string | null> | null = null

export function loadClientName(): Promise<string | null> {
  pending ??= backendUserProfilesService
    .getMyProfile()
    .then((profile) => {
      const name = profile?.client?.name ?? null
      if (!profile) pending = null
      return name
    })
    .catch(() => {
      // getMyProfile logs its own failures; the chip stays away.
      pending = null
      return null
    })
  return pending
}

/** Tests only: forget the cached name. */
export function resetClientNameCache(): void {
  pending = null
}
